import { render, staticRenderFns } from "./launch.vue?vue&type=template&id=a56e3c92"
import script from "./launch.vue?vue&type=script&lang=js"
export * from "./launch.vue?vue&type=script&lang=js"
import style0 from "./launch.vue?vue&type=style&index=0&id=a56e3c92&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a56e3c92')) {
      api.createRecord('a56e3c92', component.options)
    } else {
      api.reload('a56e3c92', component.options)
    }
    module.hot.accept("./launch.vue?vue&type=template&id=a56e3c92", function () {
      api.rerender('a56e3c92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/launch.vue"
export default component.exports